import { assetUrl, shareCaptureAssetUrl } from "~/utils/assetUrl"

export type ArchetypeImageVariant = "logos" | "portraits"

export function archetypeImageUrl(icon: string, variant: ArchetypeImageVariant = "logos"): string {
  return assetUrl(`/images/archetypes/${variant}/${icon}`)
}

export function archetypeShareCaptureUrl(
  icon: string,
  variant: ArchetypeImageVariant = "logos",
): string {
  return shareCaptureAssetUrl(`/images/archetypes/${variant}/${icon}`)
}

export function resolveArchetypeIcon(data: { archetype?: { icon: string } | null }): string {
  return data.archetype?.icon ?? "the_trailblazer.png"
}
